module.exports = __webpack_public_path__ + "img/N.a84bf0b7.webp";